module.exports = __webpack_public_path__ + "img/logo_header.c77e3de9.png";